import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BrowseGalleryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"browse_gallery"}/>
}
